var React = require('react');

function BreadcrumbArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M505.01,307l-1.668,1.6h0l-6.672,6.408-1.667-1.6L501.674,307,495,300.591l1.667-1.6,6.672,6.408h0Z","transform":"translate(-495 -299)"}));
}

BreadcrumbArrow.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16"};

module.exports = BreadcrumbArrow;

BreadcrumbArrow.default = BreadcrumbArrow;
